import {Routes, Route} from 'react-router-dom';
import DashboardPage from "./pages/DashboardPage";
import NotesPage from './modules/notes/pages/NotesPage';
import NotePage from './modules/notes/pages/NotePage';
import NoteCreatePage from './modules/notes/pages/NoteCreatePage';

export const hasAccessToPath = (path) => {
    const array = config
        .filter(o => o.path === path)
        .map(o => {
            return hasAccess(o)
        });

    return array.length ? array[0] : true;
};

const hasAccess = (routeProps) => {
     const role = 'user';// AuthService.getUserRole();

    if (routeProps.allow) {
        if (routeProps.allow.includes(role)) {
            return true
        }
        return false
    }

    if (routeProps.deny && routeProps.deny.indexOf(role) > -1) {
        return false
    }

    return true
};

const AppRouting = () => {
    return (
        <Routes>
            <Route path="/dashboard" element={<DashboardPage/>}/>

            <Route path="/notes" element={<NotesPage/>}/>
            <Route path="/notes/create" element={<NoteCreatePage/>}/>
            <Route path="/notes/:noteId" element={<NotePage/>}/>
            
            <Route path="*" element={<DashboardPage/>}/>
        </Routes>
    );
};

export default AppRouting